import userMockupData from './mock/user.json'
import buttonPermissionData from './mock/buttonPermission.json'
import userPermissionsData from './mock/userPermissions.json'
import userIdData from './mock/userId.json'
import userMyMenuMockupData from './mock/userMyMenuData.json'
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import store from '@/store'
import axios from 'axios'
import envs from '../../envs.js'

// 인증번호를 전송하는 함수
export function sendCertificateNumber(
  name,
  fromPhoneNumber,
  toPhoneNumber,
  createType
) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    console.log(createType)
    return request({
      url: `/login/auth/phone?fromPhone=${fromPhoneNumber}&phone=${toPhoneNumber}`,
      method: 'get',
      meta: { useTokenUpdate: true }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var res = toPhoneNumber.substring(3, 9)
    if (res) {
      resolve(res)
    } else {
      var error = { code: '401' }
      reject(error)
    }
  })
}
// 아이디 찾기 전용: 이름 + 전화번호로 DB 검증 후 OTP 발송
export function sendCertificateForFindId(korNm, phone) {
  if (isUseAPI()) {
    return request({
      url: `/login/auth/phone?kor_nm=${encodeURIComponent(korNm)}&phone=${encodeURIComponent(phone)}`,
      method: 'get',
      meta: { useTokenUpdate: true }
    })
  }
  return new Promise(function(resolve, reject) {
    if (korNm && phone) {
      resolve(true)
    } else {
      reject({ code: '400' })
    }
  })
}

// 비밀번호 찾기 전용: user_id + phone을 전송하여 백엔드에서 DB 일치 여부 확인 후 OTP 발송
export function sendCertificateByUserId(userId, phone) {
  if (isUseAPI()) {
    return request({
      url: `/login/auth/phone?user_id=${encodeURIComponent(userId)}&phone=${encodeURIComponent(phone)}`,
      method: 'get',
      meta: { useTokenUpdate: true }
    })
  }
  return new Promise(function(resolve, reject) {
    if (userId && phone) {
      resolve(true)
    } else {
      reject({ code: '400' })
    }
  })
}

// 사용자가 입력한 인증번호와 store 내 인증번호를 확인하는 함수
export function certificateNumberComplete(inptCertificateNumber) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: `/login/auth/confirm?authnum=${inptCertificateNumber}`,
      method: 'get',
      meta: { useErrorMessage: false }
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    if (
      store.state.user.registPhoneNumber.substring(3, 9) ===
      inptCertificateNumber
    ) {
      var success = true
      resolve(success)
    } else {
      var error = { code: '401' }
      reject(error)
    }
  })
}
// 가입시 아이디 중복 체크 함수
export function registUserDataChk(userId) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/login/users/user_id/' + userId,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  // user.json에 등록된 값을 기준으로 고유값이 이미 존재할 경우
  // 해당값을 response 로 넘겨준다.
  return new Promise(function(resolve, reject) {
    var res = _.find(userMockupData, { user_id: userId })
    if (res) {
      resolve(res)
    } else {
      var error = { code: '401' }
      reject(error)
    }
  })
}

export function registUser(data) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/join',
      method: 'post',
      data
    })
  }
}

export function findId(data) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함

  if (isUseAPI()) {
    return request({
      url: `/user/find?userId=${data.userId}&korNm=${data.name}&phone=${data.phone}`,
      method: 'get',
      meta: { useAuth: false }
    })
  }
}

export function changePassword(data) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/user/changepw`,
      method: 'post',
      meta: { useAuth: false },
      data
    })
  }
}

// 사용자 목록 조회
export function getUsers(inputData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      url: '/login/users?kor_nm=' + inputData.kor_nm,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  // mockupData 에서 조회해 온 리스트를 넘긴다.
  return new Promise(function(resolve, reject) {
    // 유저 데이터에서 검색조건과 일치하는 데이터를 찾는다.
    var returnUserList = userMockupData.filter(userData => {
      if (userData.kor_nm.includes(inputData.kor_nm)) return userData
    })
    // 검색 조건이 전부 null 이면 모든 리스트 리턴
    resolve(returnUserList)
  })
}

export function saveUsers(inputData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    if (inputData.created.length > 0) {
      return request({
        url: '/login/users',
        method: 'POST',
        data: inputData.created
      })
    }
    if (inputData.deleted.length > 0) {
      return request({
        url: '/login/users',
        method: 'DELETE',
        data: inputData.deleted
      })
    }
  }
}

// // 사용자 등록 및 수정
// export function saveUsers(gridSaveDatas) {
//   console.log('gridSaveDatas', gridSaveDatas)
//   // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
//   if (isUseAPI()) {
//     var saveActions = []
//     // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
//     var createdAction = function(rowDatas) {
//       // row 값을 보내 추가 처리
//       return request({
//         url: '/hiway/login/users',
//         method: 'post',
//         data: gridSaveDatas
//       })
//     }
//     // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
//     var updatedAction = function(rowDatas) {
//       // row 값을 보내 업데이트 처리
//       return request({
//         url: '/hiway/login/users',
//         method: 'put',
//         data: rowDatas
//       })
//     }
//     // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
//     var deletedAction = function(rowDatas) {
//       // row 값을 보내 삭제 처리
//       return request({
//         url: '/hiway/login/users',
//         method: 'delete',
//         data: rowDatas
//       })
//     }
//     // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
//     // 전체 데이터를 배열로 담아 넘긴다
//     if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
//       saveActions.push(createdAction(gridSaveDatas.created))
//     }
//     // updated 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
//     // 전체 데이터를 배열로 담아 넘긴다
//     if (gridSaveDatas.updated && gridSaveDatas.updated.length > 0) {
//       saveActions.push(updatedAction(gridSaveDatas.updated))
//     }
//     // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
//     // 전체 데이터를 배열로 담아 넘긴다
//     if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
//       saveActions.push(deletedAction(gridSaveDatas.deleted))
//     }
//     // 차후 변경될 Restful 형식에 따라 수정해야 함
//     // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
//     // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
//     return (
//       axios
//         .all(saveActions)
//         // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
//         .then(reponse => {
//           return '200'
//         })
//         .catch(error => {
//           // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
//           return error
//         })
//     )
//   }

//   // restful api를 사용하지 않을 경우
//   // 성공으로 200 코드를 넘긴다.
//   return new Promise(function(resolve, reject) {
//     resolve('200')
//   })
// }

// 사용자 버튼 권한 정보 가져오기
export function getButtonPermission() {
  if (isUseAPI()) {
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    return request({
      //      url: `/hiway/login/auth/button`,
      url: `/hiway/authusers/apps/${envs.systemId}/button`,
      method: 'get'
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(buttonPermissionData)
  })
}
export function getUserData(retrieveObj) {
  if (isUseAPI()) {
    let params = retrieveObj
    // let params = {
    //   asgn_shrt_nm: '',
    //   user_id: '',
    //   user_nm: ''
    // }
    // if (retrieveObj.asgn_shrt_nm) params.asgn_shrt_nm = retrieveObj.asgn_shrt_nm
    // if (retrieveObj.user_nm) params.user_nm = retrieveObj.user_nm
    // if (retrieveObj.user_id) params.user_id = retrieveObj.user_id

    return request({
      url: '/hiway/members',
      method: 'get',
      meta: { apiVersion: '2.0.0' },
      params
    })
    // restful api를 사용하지 않을 경우
    return new Promise(function(resolve, reject) {
      var res = userPermissionsData
      res = res.filter(item => {
        return (
          item.user_id.includes(retrieveObj.user_id) &&
          item.user_nm.includes(retrieveObj.user_nm)
        )
      })
      resolve(res)
    })
  }
}
// 사용자별 목록 조회
export function getUserAuthData(retrieveObj) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/authusers/apps/${retrieveObj.app_id}/authgroups/${retrieveObj.authgrp_cd}`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var res = userPermissionsData
    res = res.filter(item => {
      return (
        item.user_id.includes(retrieveObj.user_id) &&
        item.user_nm.includes(retrieveObj.user_nm)
      )
    })
    resolve(res)
  })
}
// 사용자별 목록 조회.
export function getUserPermissionsData(retrieveObj) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/users/${retrieveObj.user_id}/`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var res = userPermissionsData
    res = res.filter(item => {
      return (
        item.user_id.includes(retrieveObj.user_id) &&
        item.user_nm.includes(retrieveObj.user_nm)
      )
    })
    resolve(res)
  })
  // }
  // restful api를 사용하지 않을 경우
  // return new Promise(function(resolve, reject) {
  //   var res = userPermissionsData
  //   res = res.filter(item => {
  //     return (
  //       item.user_id.includes(retrieveObj.user_id) &&
  //       item.user_nm.includes(retrieveObj.user_nm)
  //     )
  //   })
  //   resolve(res)
  // })
}

// 사용자별 ID 목록 조회
export function getUserIdData(retrieveObj) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/userauths/${retrieveObj.app_id}/${retrieveObj.user_id}/${retrieveObj.menu_id}`,
      method: 'get'
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var res = userIdData[retrieveObj.user_id]
    if (!res) {
      res = userIdData['all']
    }
    resolve(res)
  })
}

export function saveUserAuth(saveDataSet) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: `/hiway/authusers/apps/${saveDataSet.parameter.system_id}/authgroups/${saveDataSet.parameter.authgrp_cd}`,
      method: 'post',
      data: saveDataSet,
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    let total = saveDataSet.created.length + saveDataSet.updated.length
    let resObj = getResultObj(total)
    resObj.created = [...saveDataSet.created]
    resObj.updated = [...saveDataSet.updated]
    resObj.created.forEach(row => {
      let ret = _.random(0, 1)
      row.ret_code = ret === 1 ? 'Y' : 'N'
      row.ret_msg = ret === 1 ? '반영완료' : '무슨문제가..'
      row.pgm_id = _.random(1000000, 9999999)
      row.is_change = ''
    })
    resObj.updated.forEach(row => {
      let ret = _.random(0, 1)
      row.ret_code = ret === 1 ? 'Y' : 'N'
      row.ret_msg = ret === 1 ? '반영완료' : '무슨문제가..'
      row.is_change = ''
    })
    resolve(resObj)
  })
}
export function deleteUserAuth(deleteDataSet, authGroupCD) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: `/hiway/authusers/apps/${envs.systemId}/authgroups/${authGroupCD.authgrp_cd}`,
      method: 'delete',
      data: deleteDataSet,
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(getResultObj(deleteDataSet.deleted.length))
  })
}
// 메뉴 그룹에 메뉴 등록 및 삭제
export function saveUserMenuData(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: `/hiway/userauths/${gridSaveDatas.retrieveData.app_id}`,
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/userauths/delete',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}

// 마이 메뉴 조회 API
export function getMyMenu(userId) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/hiway/mymenus/apps/' + envs.systemId,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }

  // restful api를 사용하지 않을 경우
  // user.json에 등록된 값을 기준으로 고유값이 이미 존재할 경우
  // 해당값을 response 로 넘겨준다.
  return new Promise(function(resolve, reject) {
    var res = userMyMenuMockupData[userId]
    if (res) {
      resolve(res)
    } else {
      var error = { code: '401' }
      reject(error)
    }
  })
}
export function newMemberPassword(retrieveObj) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/users/setpassword`,
      method: 'put',
      data: retrieveObj,
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var res = userPermissionsData
    res = res.filter(item => {
      return (
        item.user_id.includes(retrieveObj.user_id) &&
        item.user_nm.includes(retrieveObj.user_nm)
      )
    })
    resolve(res)
  })
}

// export function changePassword(retrieveObj) {
//   if (isUseAPI()) {
//     return request({
//       url: `/hiway/users/password`,
//       method: 'put',
//       data: retrieveObj,
//       meta: { apiVersion: '2.0.0' }
//     })
//   }
//   // restful api를 사용하지 않을 경우
//   return new Promise(function(resolve, reject) {
//     var res = userPermissionsData
//     res = res.filter(item => {
//       return (
//         item.user_id.includes(retrieveObj.user_id) &&
//         item.user_nm.includes(retrieveObj.user_nm)
//       )
//     })
//     resolve(res)
//   })
// }

// 마이 메뉴 저장 API
export function saveMyMenu(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/mymenus/apps/' + envs.systemId,
        method: 'post',
        data: rowDatas
      })
    }
    var updatedAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/mymenus/apps/' + envs.systemId,
        method: 'put',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/mymenus/apps/' + envs.systemId,
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // updated 에 담긴 데이터가 있으면, request put 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.updated && gridSaveDatas.updated.length > 0) {
      saveActions.push(updatedAction(gridSaveDatas.updated))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(reponse => {
          return '200'
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}
function getResultObj(count) {
  let total = count
  let s = _.random(0, total)
  let f = total - s
  let e = _.random(100, 999)
  return {
    result: {
      total: {
        count: total,
        success: s,
        fail: f
      },
      execTime: e,
      resMsg: `${total}건 중, ${s}건 성공, ${f}건 실패. ${e}ms`
    }
  }
}
export function saveExecuteMenu(menuid) {
  let data = { menu_id: '' }
  data.menu_id = menuid
  if (isUseAPI()) {
    return request({
      url: `/hiway/log/menu`,
      data,
      meta: { apiVersion: '2.0.0' },
      method: 'post'
    })
  }
}

export function initPassword() {
  if (isUseAPI()) {
    return request({
      url: `/hiway/users/initpassword`,
      meta: {
        apiVersion: '2.0.0'
      },
      method: 'put'
    })
  }
}
